import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaAlmacenamientoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FEC. ALMACEN' htmlFor='date-fechaAlmacenamiento' md={4} />
      <Col md={8}>
        <Field name='fechaAlmacenamiento'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-fechaAlmacenamiento'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaAlmacenamientoFormGroup)
